import { useEffect, useState, useCallback } from 'react';

import { useAtlassianAccountMigrationQuery } from './AtlassianAccountMigrationQuery.generated';

import { getQueryParameter } from './getQueryParameter';
import { removeQueryParameters } from './removeQueryParameters';

import { HYGIENE_MESSAGE_ID } from 'app/src/components/EmailHygieneWizard/emailHygieneOneTimeMessageIds';
import { requiresAaOnboardingTemplates } from './requiresAaOnboardingTemplates';

export function useAtlassianAccountMigrationConfirmation() {
  const [shouldShowConfirmation, setShouldShowConfirmation] = useState(false);

  const dataHook = useAtlassianAccountMigrationQuery({
    variables: { memberId: 'me' },
  });

  const me = dataHook.data && dataHook.data.member;
  const template = me?.requiresAaOnboarding?.template;

  const hasCompletedHygiene = me?.oneTimeMessagesDismissed?.includes(
    HYGIENE_MESSAGE_ID,
  );

  useEffect(() => {
    const shouldShowConfirmationOverlay =
      getQueryParameter('onboarding') === 'success';

    setShouldShowConfirmation(shouldShowConfirmationOverlay);
    // eslint-disable-next-line @trello/exhaustive-deps
  }, []);

  const renderConfirmation = () => {
    // Never show the confirmation dialog to users who are not Aa-governed.
    if (!me?.isAaMastered) {
      return false;
    }

    if (
      template === requiresAaOnboardingTemplates.ENTERPRISE ||
      template === requiresAaOnboardingTemplates.DOMAIN_CLAIM ||
      template === requiresAaOnboardingTemplates.INACTIVE
    ) {
      return true;
    }

    // If a user was actively migrated, profile sync status doesn't matter at all.
    // The user should be presented with the confirmation dialog if (and only if)
    // the query parameter is present when this component mounts.
    if (hasCompletedHygiene) {
      return shouldShowConfirmation;
    }
    return false;
  };

  const dismissConfirmation = useCallback(() => {
    removeQueryParameters('onboarding');
    setShouldShowConfirmation(false);
  }, []);

  const shouldRender = renderConfirmation();

  return {
    me,
    shouldRender,
    dismissConfirmation,
  };
}
